export const CHECKOUT_URL = 'https://art-teacher-ready.impultienda.ar/checkout'

export const META_PIXEL_ID = '1049314170929647'

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  const w = window as any
  try {
    if (!w.fbq) {
      const n: any = (w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      })
      if (!w._fbq) w._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const target = document.head || document.body || document.documentElement
      if (target) target.appendChild(script)
      w.fbq('init', META_PIXEL_ID)
    }
    w.fbq('track', 'PageView')
  } catch (err) {
    console.warn('Meta Pixel init failed:', err)
  }
}

export function trackInitiateCheckout(): void {
  if (typeof window === 'undefined') return
  const fbq = (window as any).fbq
  if (typeof fbq !== 'function') return
  fbq('track', 'InitiateCheckout', {
    content_name: 'Art Teacher Ready Complete Library',
    value: 27.0,
    currency: 'USD',
  })
}
